import React, { useState } from 'react';
// Framer Motion supprimé - utilisation d'animations CSS
import { MapContainer, TileLayer, Marker, Popup, Tooltip } from 'react-leaflet';
import { Icon } from 'leaflet';
import { 
  Users, 
  Activity, 
  Download,
  Filter,
  Search,
  Hospital,
  Heart
} from 'lucide-react';
import { mockZones } from '../../data/mockData';
import jsPDF from 'jspdf';

// Fix for default markers in react-leaflet
import L from 'leaflet';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const InteractiveMap = () => {
  const [zones] = useState(mockZones);
  const [selectedZone, setSelectedZone] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('');

  const filteredZones = zones.filter(zone => {
    const matchesSearch = zone.name.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilter = !filterStatus || zone.status === filterStatus;
    return matchesSearch && matchesFilter;
  });

  const exportToPDF = () => {
    const doc = new jsPDF();
    
    // Titre
    doc.setFontSize(20);
    doc.text('Carte des Zones de Santé - RDC', 20, 20);
    
    // Tableau
    const tableData = filteredZones.map(zone => [
      zone.name,
      zone.population.toLocaleString(),
      zone.hospitals.toString(),
      zone.doctors.toString(),
      zone.status
    ]);

    doc.autoTable({
      head: [['Zone', 'Population', 'Hôpitaux', 'Médecins', 'Statut']],
      body: tableData,
      startY: 30,
      styles: { fontSize: 10 },
      headStyles: { fillColor: [59, 130, 246] }
    });

    doc.save('carte-zones-sante.pdf');
  };

  const getZoneColor = (zone) => {
    if (zone.doctors > 100) return 'green';
    if (zone.doctors > 50) return 'orange';
    return 'red';
  };

  const getZoneIcon = (zone) => {
    const color = getZoneColor(zone);
    return new Icon({
      iconUrl: `https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-${color}.png`,
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div
          
          
          className="mb-8"
        >
          <div className="flex justify-between items-center">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">Carte Interactive des Zones de Santé</h1>
              <p className="text-gray-600 mt-2">Visualisez et gérez les zones de santé en RDC</p>
            </div>
            <button
              
              
              onClick={exportToPDF}
              className="bg-primary-600 hover:bg-primary-700 text-white px-4 py-2 rounded-lg flex items-center space-x-2 transition-colors duration-200"
            >
              <Download className="h-4 w-4" />
              <span>Exporter PDF</span>
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          {/* Sidebar */}
          <div
            
            
            
            className="lg:col-span-1 space-y-6"
          >
            {/* Search and Filter */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Filtres</h3>
              
              <div className="space-y-4">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
                  <input
                    type="text"
                    placeholder="Rechercher une zone..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                  />
                </div>
                
                <div className="relative">
                  <Filter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
                  <select
                    value={filterStatus}
                    onChange={(e) => setFilterStatus(e.target.value)}
                    className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                  >
                    <option value="">Tous les statuts</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Zones List */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Zones de Santé</h3>
              <div className="space-y-3 max-h-96 overflow-y-auto">
                {filteredZones.map((zone, index) => (
                    <div
                      key={zone.id}
                      
                      
                      
                      
                    onClick={() => setSelectedZone(zone)}
                    className={`p-3 rounded-lg border cursor-pointer transition-all duration-200 ${
                      selectedZone?.id === zone.id 
                        ? 'border-primary-500 bg-primary-50' 
                        : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
                    }`}
                  >
                    <div className="flex items-center justify-between">
                      <div>
                        <h4 className="font-medium text-gray-900">{zone.name}</h4>
                        <p className="text-sm text-gray-500">{zone.population.toLocaleString()} habitants</p>
                      </div>
                      <div className={`w-3 h-3 rounded-full ${
                        zone.status === 'Active' ? 'bg-green-500' : 'bg-red-500'
                      }`}></div>
                    </div>
                    <div className="mt-2 grid grid-cols-2 gap-2 text-xs text-gray-600">
                      <div className="flex items-center">
                        <Hospital className="h-3 w-3 mr-1" />
                        {zone.hospitals} hôpitaux
                      </div>
                      <div className="flex items-center">
                        <Users className="h-3 w-3 mr-1" />
                        {zone.doctors} médecins
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Statistics */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Statistiques</h3>
              <div className="space-y-3">
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600">Total des zones</span>
                  <span className="font-semibold text-gray-900">{zones.length}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600">Population totale</span>
                  <span className="font-semibold text-gray-900">
                    {zones.reduce((sum, zone) => sum + zone.population, 0).toLocaleString()}
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600">Médecins total</span>
                  <span className="font-semibold text-gray-900">
                    {zones.reduce((sum, zone) => sum + zone.doctors, 0)}
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600">Hôpitaux total</span>
                  <span className="font-semibold text-gray-900">
                    {zones.reduce((sum, zone) => sum + zone.hospitals, 0)}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Map */}
          <div
            
            
            
            className="lg:col-span-4"
          >
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden h-[600px]">
              <MapContainer
                center={[-4.4419, 15.2663]}
                zoom={6}
                style={{ height: '100%', width: '100%' }}
              >
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />
                {filteredZones.map((zone) => (
                  <Marker
                    key={zone.id}
                    position={zone.coordinates}
                    icon={getZoneIcon(zone)}
                  >
                    <Popup>
                      <div className="p-2">
                        <h3 className="font-semibold text-lg text-gray-900 mb-2">{zone.name}</h3>
                        <div className="space-y-1 text-sm">
                          <div className="flex items-center">
                            <Users className="h-4 w-4 text-gray-500 mr-2" />
                            <span>{zone.population.toLocaleString()} habitants</span>
                          </div>
                          <div className="flex items-center">
                            <Hospital className="h-4 w-4 text-gray-500 mr-2" />
                            <span>{zone.hospitals} hôpitaux</span>
                          </div>
                          <div className="flex items-center">
                            <Heart className="h-4 w-4 text-gray-500 mr-2" />
                            <span>{zone.doctors} médecins</span>
                          </div>
                          <div className="flex items-center">
                            <Activity className="h-4 w-4 text-gray-500 mr-2" />
                            <span className={`px-2 py-1 rounded-full text-xs ${
                              zone.status === 'Active' 
                                ? 'bg-green-100 text-green-800' 
                                : 'bg-red-100 text-red-800'
                            }`}>
                              {zone.status}
                            </span>
                          </div>
                        </div>
                      </div>
                    </Popup>
                    <Tooltip direction="top" offset={[0, -10]} opacity={1}>
                      <div className="text-center">
                        <div className="font-semibold">{zone.name}</div>
                        <div className="text-xs">{zone.doctors} médecins</div>
                      </div>
                    </Tooltip>
                  </Marker>
                ))}
              </MapContainer>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InteractiveMap;
